import { useNotices } from '@/hooks';
import { Add as AddIcon, Done as DoneIcon } from '@mui/icons-material';
import {
  Avatar,
  Box,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { Fragment, useState } from 'react';
import { Notice } from './Notice';
import { NoticeEditor } from './NoticeEditor';

export function InspectorsNoticeBoard({ groupCodes, onComplete }) {
  const { data: notices } = useNotices({ groups: groupCodes });
  const [editCode, setEditCode] = useState(null);

  function handleSettingsClick(code) {
    return function () {
      setEditCode(code);
    };
  }

  function handleAddClick() {
    setEditCode('new');
  }

  function onEditorClose() {
    setEditCode(null);
  }

  function handleCompleteClick() {
    onComplete();
  }

  return (
    <Fragment>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{
          position: 'sticky',
          top: 48,
          backgroundColor: 'background.default',
          zIndex: 700,
          pl: 1,
          py: 1,
        }}
      >
        <Typography variant="h6">Inspectors Notice Board</Typography>
        <Box>
          <Tooltip title="Done" placement="right">
            <IconButton onClick={handleCompleteClick}>
              <DoneIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        <Box>
          <Tooltip title="Add" placement="left">
            <IconButton size="small" onClick={handleAddClick}>
              <Avatar
                sx={{
                  color: 'secondary.contrastText',
                  bgcolor: 'secondary.main',
                  width: 32,
                  height: 32,
                  fontSize: 24,
                }}
              >
                <AddIcon fontSize="inherit" />
              </Avatar>
            </IconButton>
          </Tooltip>
        </Box>
      </Stack>
      <Stack spacing={1} sx={{ pb: 1 }}>
        {notices.map((notice) => (
          <Notice
            key={notice.code}
            notice={notice}
            onSettingsClick={handleSettingsClick(notice.code)}
          />
        ))}
      </Stack>
      <NoticeEditor
        code={editCode}
        isOpen={Boolean(editCode)}
        onClose={onEditorClose}
        groupCodes={groupCodes}
      />
    </Fragment>
  );
}
